import type { Artifact } from "@/lib/types";

// Artifacts are user-facing "Deliverables" — concrete, openable things
// (docs, decks, Looms, designs) attached to exactly one task.
// In code the original Sheet-backed `deliverables` entity represents Tasks;
// this separate `artifacts` entity holds the links/assets that ship from them.
export const ARTIFACTS: Artifact[] = [];
